import Success from '@assets/icons/success.svg'
import { Icon } from './Icon'

export const SuccessIcon = Icon(Success)
